import React from 'react';
import { AnimatePresence, motion } from 'framer-motion';
import { Link } from 'gatsby';
import { useNavQuery } from '@querys/useNavQuery';
import { useSiteContext, useSubscriptionOpen } from '../../lib/context';
import { useScrollFreeze } from '@hooks/useScrollFreeze';

import Arrow from '@svg/arrow-white.svg';

const menuVars = {
  mainVars: {
    initial: {
      x: '-100%',
    },
    animate: {
      x: 0,
      transition: {
        duration: 0.3,
        when: 'beforeChildren',
        staggerChildren: 0.1,
      },
    },
    exit: {
      x: '-100%',
      transition: {
        duration: 0.3,
        when: 'beforeChildren',
        staggerChildren: 0.1,
      },
    },
  },
  subVars: {
    initial: {
      x: '100%',
    },
    animate: {
      x: 0,
      transition: {
        duration: 0.3,
        when: 'beforeChildren',
        staggerChildren: 0.1,
      },
    },
    exit: {
      x: '100%',
      transition: {
        duration: 0.3,
        when: 'beforeChildren',
        staggerChildren: 0.1,
      },
    },
  },
};

const SubMenu = ({ toggleMore }) => {
  const { sideMenu } = useNavQuery();
  return (
    <motion.div
      variants={menuVars.subVars}
      initial='initial'
      animate='animate'
      exit='exit'
      className='w-full pt-44 pb-24 px-gutter flex flex-col justify-between min-h-screen self-stretch text-white gap-y-4 mx-gutter'>
      <button
        onClick={toggleMore}
        className='blockH7 font-bold text-left flex items-center gap-x-3 mb-4'>
        <Arrow className='w-6 rotate-180' />
        <span>Back</span>
      </button>

      {sideMenu?.map(({ linkText, page }, i) => (
        <Link key={i} to={`/${page?.slug?.current}`} className='blockH7'>
          <span className='block font-bold'>{linkText}</span>
        </Link>
      ))}
    </motion.div>
  );
};

const MainMenu = ({ toggleMore, toggleOpen }) => {
  const { mainMenu } = useNavQuery();
  const { state } = useSiteContext();
  return (
    <motion.div
      variants={menuVars.mainVars}
      initial='initial'
      animate='animate'
      exit='exit'
      className='self-stretch w-full pt-44 pb-24 px-gutter flex flex-col justify-between text-white gap-y-4 mx-gutter'>
      {mainMenu?.map(({ page, linkText, maoriLinkText, _type }, i) => (
        <Link
          key={i}
          to={`/${page?.slug?.current}`}
          activeStyle={{ opacity: '60%' }}
          className='blockH8  xl:block hover:opacity-60 transition-standard'>
          <span className='block'>{maoriLinkText}</span>
          <span className='block mt-1 font-bold'>{linkText}</span>
        </Link>
      ))}
      <button
        variants={menuVars.mainVars}
        onClick={toggleMore}
        className='blockH7 font-bold text-left flex items-center gap-x-3'>
        <span>Explore more</span>
        <Arrow className='w-6' />
      </button>
    </motion.div>
  );
};

export const NavModal = ({ toggleOpen }) => {
  useScrollFreeze();
  const [exploreMore, setExploreMore] = React.useState(false);
  const toggleMore = () => setExploreMore((prev) => !prev);

  return (
    <motion.div
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      exit={{ opacity: 0 }}
      className='bg-teal w-full fixed top-0 left-0 z-40'>
      <div className='min-h-screen flex'>
        <AnimatePresence exitBeforeEnter>
          {exploreMore ? (
            <SubMenu key={exploreMore} toggleMore={toggleMore} />
          ) : (
            <MainMenu
              key={exploreMore}
              toggleMore={toggleMore}
              toggleOpen={toggleOpen}
            />
          )}
        </AnimatePresence>
      </div>
    </motion.div>
  );
};
